import React, { useState, useEffect } from "react";
import Login from "./views/login/login";
import Dashboard from "./views/dashboard/dashboard";
import CondoUnits from "./views/condo-units/condoUnits";
import CondoUnitDetail from "./views/condo-units/viewCondoUnit";
import CondoPayment from "./views/condo-payment/condoPayment";
import PaymentSummary from "./views/payment-summary/paymentSummary";
import MonthlyHeadcount from "./views/monthly-headcount/monthlyHeadcount";
import SubmitRf from "./views/submit-rf/submitRf";
import EditRf from "./views/edit-rf/editRf";
import StayInEmployees from "./views/stay-in-employees/stayInEmployees";
import StayOutHistory from "./views/stay-out-history/stayOutHistory";
import StayInHistory from "./views/stay-in-history/stayInHistory";
import LockPeriod from "./views/lock-period/lockPeriod";
import ExpenseSummary from "./views/expense-summary/expenseSummary";
import RfHistory from "./views/rf-history/rfHistory";
import Settings from "./views/settings/settings";
import ViewOccupancy from "./views/view-occupancy/viewOccupancy";
import UnderConstruction from "./views/under-construction/underConstruction";
import { ToastProvider } from "./components/shared/ToastProvider";
import favicon from "./images/favicon.png";

export default function App() {
  useEffect(() => {
    if (typeof document === "undefined") return;

    let link = document.querySelector("link[rel='icon']");
    if (!link) {
      link = document.createElement("link");
      link.rel = "icon";
      document.head.appendChild(link);
    }
    link.type = "image/png";
    link.href = favicon;
  }, []);

  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [activePage, setActivePage] = useState("dashboard");

  const handleLogin = () => {
    setIsAuthenticated(true);
    setActivePage("dashboard");
  };

  const handleLogout = () => {
    setIsAuthenticated(false);
    setActivePage("dashboard");
  };

  const handleNavigate = (item) => {
    if (!item || !item.key) {
      return;
    }

    switch (item.key) {
      case "dashboard":
      case "condo-units":
      case "condo-payment":
      case "payment-summary":
      case "condo-unit-detail":
      case "submit-rf":
      case "edit-rf":
      case "view-occupancy":
      case "stay-in-employees":
      case "stay-out-history":
      case "stay-in-history":
      case "rf-history":
      case "lock-period":
      case "expense-summary":
      case "dorm-movement":
      case "monthly-headcount":
      case "settings":
        setActivePage(item.key);
        break;
      default:
        setActivePage("dashboard");
        break;
    }
  };

  if (isAuthenticated) {
    const sharedProps = {
      onLogout: handleLogout,
      onNavigate: handleNavigate
    };

    // Page name mapping for under construction pages
    const underConstructionPages = {
      "dorm-movement": "Dorm Movement"
    };

    // Check if current page is under construction
    if (underConstructionPages[activePage]) {
      return (
        <ToastProvider>
          <UnderConstruction pageName={underConstructionPages[activePage]} {...sharedProps} />
        </ToastProvider>
      );
    }

    if (activePage === "condo-units") {
      return (
        <ToastProvider>
          <CondoUnits {...sharedProps} />
        </ToastProvider>
      );
    }

    if (activePage === "condo-payment") {
      return (
        <ToastProvider>
          <CondoPayment {...sharedProps} />
        </ToastProvider>
      );
    }

    if (activePage === "view-occupancy") {
      return (
        <ToastProvider>
          <ViewOccupancy {...sharedProps} />
        </ToastProvider>
      );
    }

    if (activePage === "payment-summary") {
      return (
        <ToastProvider>
          <PaymentSummary {...sharedProps} />
        </ToastProvider>
      );
    }

    if (activePage === "monthly-headcount") {
      return (
        <ToastProvider>
          <MonthlyHeadcount {...sharedProps} />
        </ToastProvider>
      );
    }

    if (activePage === "condo-unit-detail") {
      return (
        <ToastProvider>
          <CondoUnitDetail {...sharedProps} />
        </ToastProvider>
      );
    }

    if (activePage === "submit-rf") {
      return (
        <ToastProvider>
          <SubmitRf {...sharedProps} />
        </ToastProvider>
      );
    }

    if (activePage === "edit-rf") {
      return (
        <ToastProvider>
          <EditRf {...sharedProps} />
        </ToastProvider>
      );
    }

    if (activePage === "stay-in-employees") {
      return (
        <ToastProvider>
          <StayInEmployees {...sharedProps} />
        </ToastProvider>
      );
    }

    if (activePage === "stay-out-history") {
      return (
        <ToastProvider>
          <StayOutHistory {...sharedProps} />
        </ToastProvider>
      );
    }

    if (activePage === "stay-in-history") {
      return (
        <ToastProvider>
          <StayInHistory {...sharedProps} />
        </ToastProvider>
      );
    }

    if (activePage === "lock-period") {
      return (
        <ToastProvider>
          <LockPeriod {...sharedProps} />
        </ToastProvider>
      );
    }

    if (activePage === "expense-summary") {
      return (
        <ToastProvider>
          <ExpenseSummary {...sharedProps} />
        </ToastProvider>
      );
    }

    if (activePage === "rf-history") {
      return (
        <ToastProvider>
          <RfHistory {...sharedProps} />
        </ToastProvider>
      );
    }

    if (activePage === "settings") {
      return (
        <ToastProvider>
          <Settings {...sharedProps} />
        </ToastProvider>
      );
    }

    return (
      <ToastProvider>
        <Dashboard {...sharedProps} />
      </ToastProvider>
    );
  }

  return (
    <ToastProvider>
      <Login onLogin={handleLogin} />
    </ToastProvider>
  );
}
